module.exports = __webpack_public_path__ + "static/img/muzyka-80px.fd33c834.png";